import appContent from '@/services/content/appContent.typed';

const AutoDeliveryDcxNextDeliveryTitle = () => {
    const {nextDeliveryTitle} = appContent.getAutoDeliveryContent()?.dashboardContent || {};

    if (!nextDeliveryTitle) return null;

    return <div className='text-14 leading-[20px] tracking-04'>{nextDeliveryTitle}</div>;
};

export default AutoDeliveryDcxNextDeliveryTitle;
